/* Second Bloom — favourites saved in the shopper's browser, hearts on product cards */
(function () {
  if (window.SBFav) return;
  var KEY = 'sb_saved_v1';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20c-1.2 0-9-5-9-10.6C3 6.5 5.1 4.5 7.6 4.5c1.9 0 3.4 1.1 4.4 2.6 1-1.5 2.5-2.6 4.4-2.6 2.5 0 4.6 2 4.6 4.9C21 15 13.2 20 12 20z"/></svg>';

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  // Pieces the Saved page found archived ("found a new home") stay saved but aren't counted.
  function live(list) { return list.filter(function (x) { return !x.gone; }); }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sb:favourites-changed', { detail: { count: live(list).length } }));
  }

  var api = {
    heart: HEART,
    list: read,
    count: function () { return live(read()).length; },
    has: function (h) { return read().some(function (x) { return x.h === h; }); },
    add: function (item) {
      var list = read().filter(function (x) { return x.h !== item.h; });
      list.unshift(Object.assign({ t: Date.now() }, item));
      write(list);
    },
    remove: function (h) { write(read().filter(function (x) { return x.h !== h; })); },
    update: function (h, data) {
      var list = read();
      var it = list.find(function (x) { return x.h === h; });
      if (!it) return;
      Object.assign(it, data);
      write(list);
    }
  };
  window.SBFav = api;

  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // White heart by default; switch to dark when the photo's corner is very light.
  function setTone(btn, img) {
    function run() {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h || w < 40) return;
        var c = document.createElement('canvas');
        c.width = 8; c.height = 8;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, w * 0.8, h * 0.84, w * 0.2, h * 0.16, 0, 0, 8, 8);
        var d = ctx.getImageData(0, 0, 8, 8).data, sum = 0;
        for (var i = 0; i < d.length; i += 4) sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        btn.classList.toggle('sbn-heart--dark', sum / 64 > 185);
      } catch (e) { /* cross-origin image: keep the white heart */ }
    }
    if (img.complete && img.naturalWidth > 40) run();
    img.addEventListener('load', run);
    img.addEventListener('lazyloaded', run);
  }

  function sync(btn) {
    var on = api.has(btn.dataset.sbHandle);
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function syncAll() { document.querySelectorAll('.sbn-heart[data-sb-handle]').forEach(sync); }

  function decorate() {
    document.querySelectorAll('product-card .product-featured-image:not([data-sb-hearted])').forEach(function (fig) {
      fig.setAttribute('data-sb-hearted', '1');
      var link = fig.querySelector('a[href*="/products/"]');
      var h = handleFrom(link && link.getAttribute('href'));
      if (!h) return;
      var card = fig.closest('product-card');
      var titleEl = card && card.querySelector('.product-card-title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sbn-heart';
      btn.dataset.sbHandle = h;
      btn.setAttribute('aria-label', 'Save ' + title);
      btn.innerHTML = HEART;
      fig.appendChild(btn);
      var img = fig.querySelector('.product-primary-image') || fig.querySelector('img');
      if (img) setTone(btn, img);
      sync(btn);
    });

    // Product page: a heart in the bottom-right corner of every gallery photo.
    var pm = location.pathname.match(/\/products\/([^/?#]+)/);
    if (pm) {
      var ph = decodeURIComponent(pm[1]);
      document.querySelectorAll('product-slider .product-images__slide:not([data-sb-hearted])').forEach(function (slide) {
        slide.setAttribute('data-sb-hearted', '1');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sbn-heart sbn-heart--pdp';
        btn.dataset.sbHandle = ph;
        btn.setAttribute('aria-label', 'Save this piece');
        btn.innerHTML = HEART;
        // Keep the gallery from treating a tap on the heart as a swipe or a zoom.
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
          btn.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
        });
        slide.appendChild(btn);
        var img = slide.querySelector('img');
        if (img) setTone(btn, img);
        sync(btn);
      });
    }

    // Desktop header: a Saved link next to Search.
    var left = document.querySelector('[class*="ai-header-left-"]');
    var search = left && left.querySelector('a[class*="ai-header-icon-"]');
    if (search && !left.querySelector('.sbn-hdr-saved')) {
      var tab = document.querySelector('sb-mobile-nav a.sbn-tabbar__item[href*="/pages/"]');
      var a = document.createElement('a');
      a.href = tab ? tab.getAttribute('href') : '/pages/saved';
      a.className = search.className + ' sbn-hdr-saved';
      a.setAttribute('aria-label', 'Saved');
      a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 20c-1.2 0-9-5-9-10.6C3 6.5 5.1 4.5 7.6 4.5c1.9 0 3.4 1.1 4.4 2.6 1-1.5 2.5-2.6 4.4-2.6 2.5 0 4.6 2 4.6 4.9C21 15 13.2 20 12 20z"/></svg><span class="sbn-hdr-badge" hidden></span>';
      if (location.pathname === a.getAttribute('href')) a.classList.add('is-current');
      search.parentNode.insertBefore(a, search.nextSibling);
      headerCount();
    }
  }

  function headerCount() {
    document.querySelectorAll('.sbn-hdr-saved .sbn-hdr-badge').forEach(function (b) {
      var n = api.count();
      b.textContent = n;
      b.hidden = n === 0;
      b.parentNode.setAttribute('aria-label', n ? 'Saved, ' + n + (n === 1 ? ' piece' : ' pieces') : 'Saved');
    });
  }

  function track(p) {
    if (typeof window.fbq !== 'function' || !p) return;
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EGP';
      window.fbq('track', 'AddToWishlist', {
        content_ids: [String(p.id)], content_type: 'product', content_name: p.title,
        value: p.price / 100, currency: currency
      });
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sbn-heart[data-sb-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.dataset.sbHandle;
    if (api.has(h)) { api.remove(h); return; }
    var card = btn.closest('product-card');
    var img = card && card.querySelector('.product-primary-image');
    var titleEl = card && card.querySelector('.product-card-title');
    api.add({ h: h, title: titleEl ? titleEl.textContent.trim() : '', img: img ? (img.currentSrc || img.src) : '' });
    btn.classList.remove('sbn-pop');
    void btn.offsetWidth;
    btn.classList.add('sbn-pop');
    fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        api.update(h, { id: p.id, title: p.title, vendor: p.vendor, price: p.price, img: p.featured_image, type: p.type });
        track(p);
      })
      .catch(function () {});
  }, true);

  document.addEventListener('sb:favourites-changed', function () { syncAll(); headerCount(); });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('sb:favourites-changed'));
  });

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; decorate(); }, 80);
  }
  function start() {
    decorate();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Second Bloom — swipe through a product's photos on product cards (replaces the hover-slider app) */
(function () {
  if (window.__sbCardSlider) return;
  window.__sbCardSlider = true;

  var CHEVRON = '<svg viewBox="0 0 512 512" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M184 112l144 144-144 144"/></svg>';
  var touch = window.matchMedia('(hover: none)').matches;
  if (touch) document.documentElement.classList.add('sbn-touch');

  function Slider(fig) {
    var urls = (fig.getAttribute('data-sb-images') || '').split('|').filter(Boolean);
    var link = fig.querySelector('.product-featured-image-link');
    var first = link && link.querySelector('.product-primary-image');
    if (!urls.length || !link || !first) return;

    this.fig = fig; this.link = link; this.urls = urls; this.first = first;
    this.n = urls.length + 1; this.i = 0; this.pos = 1; this.loaded = false;

    // Slides: [copy of last] [photo 1 ... photo n] [copy of first], so it can loop both ways.
    var track = document.createElement('div');
    track.className = 'sbn-slides';
    link.insertBefore(track, first);
    function slide() { var s = document.createElement('div'); s.className = 'sbn-slide'; track.appendChild(s); return s; }
    this.cloneLast = slide();
    var s0 = slide();
    s0.appendChild(first);
    this.real = [s0];
    for (var k = 0; k < urls.length; k++) this.real.push(slide());
    this.cloneFirst = slide();
    this.track = track;

    var arrows = document.createElement('div');
    arrows.className = 'sbn-arrows';
    arrows.innerHTML = '<button type="button" class="sbn-arrow sbn-arrow--prev" aria-label="Previous photo">' + CHEVRON + '</button>' +
      '<button type="button" class="sbn-arrow sbn-arrow--next" aria-label="Next photo">' + CHEVRON + '</button>';
    var dots = document.createElement('div');
    dots.className = 'sbn-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var d = 0; d < this.n; d++) dots.appendChild(document.createElement('span'));
    fig.appendChild(arrows);
    fig.appendChild(dots);
    this.dots = dots.children;
    fig.classList.add('sbn-has-slides');

    var self = this;
    arrows.addEventListener('click', function (e) {
      var b = e.target.closest('.sbn-arrow');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      self.go(self.i + (b.classList.contains('sbn-arrow--next') ? 1 : -1));
    });
    track.addEventListener('transitionend', function (e) { if (e.target === track) self.settle(); });
    fig.addEventListener('mouseenter', function () { self.load(); }, { passive: true });
    this.bindSwipe();
    this.render(false);
  }

  function addImg(slide, src) {
    if (!src || slide.firstChild) return;
    var img = document.createElement('img');
    img.alt = '';
    img.decoding = 'async';
    img.draggable = false;
    img.src = src;
    slide.appendChild(img);
  }

  Slider.prototype.load = function (onlyNext) {
    if (this.loaded) return;
    var upto = onlyNext ? 1 : this.urls.length;
    for (var k = 0; k < upto; k++) addImg(this.real[k + 1], this.urls[k]);
    if (onlyNext) return;
    addImg(this.cloneLast, this.urls[this.urls.length - 1]);
    addImg(this.cloneFirst, this.first.currentSrc || this.first.src);
    this.loaded = true;
  };

  // Once a slide finishes: jump silently from a copy to the real photo, and hide the neighbours
  // so no sliver of the next photo peeks through at the edge.
  Slider.prototype.settle = function () {
    clearTimeout(this.settleTimer);
    this.pos = this.i + 1;
    this.render(false);
  };

  Slider.prototype.go = function (to) {
    this.load();
    if (this.pos !== this.i + 1) { this.settle(); void this.track.offsetWidth; }
    this.i = (to % this.n + this.n) % this.n;
    this.pos = to < 0 ? 0 : to >= this.n ? this.n + 1 : to + 1;
    this.render(true);
    var self = this;
    clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(function () { self.settle(); }, 450);
  };

  Slider.prototype.render = function (animate, dragPx) {
    this.track.style.transition = animate ? '' : 'none';
    this.track.style.transform = 'translate3d(calc(' + (-this.pos * 100) + '% + ' + (dragPx || 0) + 'px), 0, 0)';
    this.track.classList.toggle('is-moving', !!(animate || dragPx));
    var kids = this.track.children;
    for (var k = 0; k < kids.length; k++) kids[k].classList.toggle('is-current', k === this.pos);
    for (var d = 0; d < this.dots.length; d++) this.dots[d].classList.toggle('is-current', d === this.i);
  };

  Slider.prototype.bindSwipe = function () {
    var self = this, link = this.link;
    var x0 = 0, y0 = 0, t0 = 0, dx = 0, mode = null, id = null, swiped = false;

    link.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      id = e.pointerId; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); dx = 0; mode = null; swiped = false;
      self.load();
      if (self.pos !== self.i + 1) self.settle();
    }, { passive: true });

    link.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (!mode) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        mode = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (mode === 'x') { try { link.setPointerCapture(id); } catch (err) {} }
      }
      if (mode !== 'x') return;
      dx = mx;
      self.render(false, dx);
    }, { passive: true });

    function end(e) {
      if (e.pointerId !== id) return;
      id = null;
      if (mode !== 'x') return;
      swiped = true;
      var w = link.offsetWidth || 1;
      var fast = Math.abs(dx) > 30 && Date.now() - t0 < 300;
      var step = (Math.abs(dx) > w * 0.2 || fast) ? (dx < 0 ? 1 : -1) : 0;
      self.go(self.i + step);
    }
    link.addEventListener('pointerup', end);
    link.addEventListener('pointercancel', end);

    // A swipe must never open the product.
    link.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);
    link.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  // Load the second photo once a card is close to the screen, so the first swipe is instant.
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var s = en.target.__sbSlider;
      if (s) s.load(true);
    });
  }, { rootMargin: '200px 0px' }) : null;

  function init() {
    document.querySelectorAll('figure.product-featured-image[data-sb-images]:not([data-sb-slider])').forEach(function (fig) {
      fig.setAttribute('data-sb-slider', '1');
      var s = new Slider(fig);
      if (!s.track) return;
      fig.__sbSlider = s;
      if (io) io.observe(fig);
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; init(); }, 60);
  }
  function start() {
    init();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
